/*
 DESCRIPTION: Custom Methods JS
 VERSION: 1.0
 ##TABLE OF CONTENT##

 1.Brands PopUp
 2.Show to products home
 3.On Scroll put a bg on header
 4.Back to Top Btn
 5.Home Slider
 6.Toggle Active Tab on Technology Section
 7. Contact Form
 8. Warranty Claim Form Handler
 9. Mobile Menu
 10. Video Modal
 */

var custom_js_theme = (function () {
    /*(1) Brands PopUp
       =================================================== */
    function showBrandsPopup() {
        var selector = jQuery(".brands-container");
        selector.css("display", "block");
        selector.css("opacity", "1");
    }

    /**
     * @function hideBrandsPopup Improved and overloaded version for matching the closing logic to the respective popover
     * @update by Javier Colmenárez
     * @param {string} ctx A jQuery selector string that works as context for constraining the jQuery main selector
     * @param {string | undefined} addElem A conditional jQuery selector for adding more elements in the set that will update their display and opacity props
     */
    function hideBrandsPopup(ctx, addElem) {
        var selector = jQuery(".brands-container", ctx).add(addElem);
        selector.css("opacity", "0");
        selector.css("display", "none");
    }

    /*(2) Show to products home
           =================================================== */
    function topProducts(button) {
        if (button.hasClass('opened')) {
            jQuery("#turbo-air_top_products .hidden")
                .slideUp({
                    duration: 500
                });
            jQuery(".see-all-products-series .btn.cta").removeClass('hidden');
            jQuery(".collapse-products").css({"display": 'none'}).removeClass('opened');
            jQuery(".cta-container").find('.fa-angle-double-down').removeClass('hidden');
        } else {
            jQuery("#turbo-air_top_products .hidden")
                .slideDown({
                    duration: 500
                });
            jQuery(".see-all-products-series .btn.cta").addClass('hidden')
            jQuery(".collapse-products").css({"display": 'block'}).addClass('opened');
            jQuery(".cta-container").find('.fa-angle-double-down').addClass('hidden');
        }
    }

    /*(2) Show to recently viewed products
         =================================================== */


    function relatedPartsCarousel(button) {
        if (button.hasClass('opened')) {
            jQuery(".FullWidthCarousel-slider").parents('.FullWidthCarousel-sliderWrapper').animate({
                height: 230
            }, 500, 'linear', () => {
                button.css({'display': 'none'}).removeClass('opened');
                jQuery(".FullWidthCarousel-footerBtn").removeAttr('style');
                jQuery(".FullWidthCarousel-slider").parents('.FullWidthCarousel-sliderContainer').find('.FullWidthCarousel-navContainer').removeAttr('style');
                jQuery(".FullWidthCarousel-slider").slick({
                    infinite: true,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    pauseOnHover: false,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    arrows: true,
                    //Adding a selector to use target elems as the nav arrows and ensure responsiveness according to design
                    prevArrow: '.FullWidthCarousel-navBtn--prev',
                    nextArrow: '.FullWidthCarousel-navBtn--next',
                    variableWidth: true,
                    //ToDo: Improve this responsive logic for the arrows and the slides to show in some breakpoints
                    responsive: [
                        {
                            breakpoint: 1280,
                            settings: {
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 736,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 484,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
                jQuery(".FullWidthCarousel-slider").find('.FullWidthCarousel-slide').removeClass('FullWidthCarousel-slide--removeSlick');
            });

            jQuery(".FullWidthCarousel-slider").parents('.FullWidthCarousel-sliderContainer').animate({
                height: 390
            }, 500);

        } else {
            jQuery(".FullWidthCarousel-slider").slick('unslick');
            jQuery(".FullWidthCarousel-slider").find('.FullWidthCarousel-slide').addClass('FullWidthCarousel-slide--removeSlick');
            jQuery(".FullWidthCarousel-slider").parents('.FullWidthCarousel-sliderContainer').find('.FullWidthCarousel-navContainer').css({'visibility': 'hidden'});

            let numCol = 5;
            let defaultCarouselMarginBottom = 85;
            if ($(window).width() > 1024 && $(window).width() < 1280) {
                numCol = 4;
                defaultCarouselMarginBottom = 72;
            } else if ($(window).width() > 736 && $(window).width() < 1024) {
                numCol = 3;
                defaultCarouselMarginBottom = 69;
            } else if ($(window).width() > 484 && $(window).width() < 736) {
                numCol = 2;
                defaultCarouselMarginBottom = 58;
            } else if ($(window).width() < 484) {
                numCol = 1;
                defaultCarouselMarginBottom = 46;
            }

            let defaultCarouselHeight = 198.3;

            let rowNum = Math.ceil(jQuery(".FullWidthCarousel-slider").find('.FullWidthCarousel-slide').length / numCol);

            jQuery(".FullWidthCarousel-slider").parents('.FullWidthCarousel-sliderWrapper').animate({
                height: (defaultCarouselHeight * rowNum) + (defaultCarouselMarginBottom * rowNum)
            }, 500, 'linear', () => {
                button.css({'display': 'none'});
                jQuery(".collapse-products").css({"display": 'block'}).addClass('opened');
            });

            jQuery(".FullWidthCarousel-slider").parents('.FullWidthCarousel-sliderContainer').animate({
                height: (defaultCarouselHeight * rowNum) + (defaultCarouselMarginBottom * rowNum)
            }, 500);
        }
    }

    /*(3) On Scroll put a bg on header
          =================================================== */
    function headerFixedBg() {
        var $siteHeader = jQuery("#site-header");
        // On scrolling
        jQuery(window).scroll(function () {
            if (jQuery(this).scrollTop() > 100) {
                $siteHeader.addClass("bg-dark");
            } else {
                $siteHeader.removeClass("bg-dark");
            }
        });
        //If the page is re-loaded
        window.onload = function () {
            if (jQuery(this).scrollTop() > 100) {
                $siteHeader.addClass("bg-dark");
            } else {
                $siteHeader.removeClass("bg-dark");
            }
        };
    }

    /*(4) Back to Top Btn
          =================================================== */
    function backToTopBtn() {
        jQuery(window).scroll(function () {
            if (jQuery(this).scrollTop() > 100) {
                jQuery(".scrollToTop").fadeIn();
            } else {
                jQuery(".scrollToTop").fadeOut();
            }
        });
        jQuery(".scrollToTop").click(function () {
            jQuery("html, body").animate({scrollTop: 0}, 800);
            return false;
        });
    }

    /*(5) Home Slider
              =================================================== */


    function homeSliderHandler() {
        var homeSliderHeight = jQuery('.turbo-air-slider').outerHeight();
        jQuery(window).on('scroll', function () {
            jQuery('.turbo-air-slider').slick(window.pageYOffset >= homeSliderHeight ? 'slickPause' : 'slickPlay');
        });
        jQuery(document).on("click", "#slick-pause", function () {
            jQuery(".turbo-air-slider").slick('slickSetOption', 'autoplay', false).slick('slickPause');
            jQuery("#slick-pause").css("display", "none");
            jQuery("#slick-play").css("display", "inline-block");
            console.log('paused');
            return false;
        });

        jQuery(document).on("click", "#slick-play", function () {
            jQuery(".turbo-air-slider").slick('slickSetOption', 'autoplay', true).slick('slickPlay');
            jQuery("#slick-play").css("display", "none");
            jQuery("#slick-pause").css("display", "inline-block");
            console.log('play');
            return false;
        });

        jQuery('.turbo-air-slider').on('beforeChange', function (event, slick, currSlide, nextSlide) {
            jQuery('#site-header').css('background-image', slick.$slides[nextSlide].style.backgroundImage);
        });
    }

    /*(6) Toggle Active Tab on Technology Section
                 =================================================== */
    function toggleActiveColorTabs() {
        jQuery(document).on("click", ".color_tabs", function () {
            $(this).addClass("active");
            $(this).siblings().removeClass("active");
        });
        jQuery(document).on("click", ".close_btn", function () {
            $(this).parent().removeClass("active");
        });
        var selector = $(".top_menu");
        var rectangle = $(".rectangle_tech");
        jQuery(document).on("click", "a.innovation", function () {
            selector.removeClass();
            selector.addClass("top_menu red");
            rectangle.removeClass();
            rectangle.addClass("rectangle_tech red");
            if ($('a[href="#technology"]').length) {
                $('a[href="#technology"]').trigger('click');
            }
        });
        jQuery(document).on("click", "a.core", function () {
            selector.removeClass();
            selector.addClass("top_menu blue");
            rectangle.removeClass();
            rectangle.addClass("rectangle_tech blue");
            if ($('a[href="#technology"]').length) {
                $('a[href="#technology"]').trigger('click');
            }
        });
        jQuery(document).on("click", "a.sustainability", function () {
            selector.removeClass();
            selector.addClass("top_menu green");
            rectangle.removeClass();
            rectangle.addClass("rectangle_tech green");
            if ($('a[href="#technology"]').length) {
                $('a[href="#technology"]').trigger('click');
            }
        });
        jQuery(document).on("click", "a.eco", function () {
            selector.removeClass();
            selector.addClass("top_menu purple");
            rectangle.removeClass();
            rectangle.addClass("rectangle_tech purple");
            if ($('a[href="#technology"]').length) {
                $('a[href="#technology"]').trigger('click');
            }
        });
    }



    /*(6) Toggle from grid to column on products
                =================================================== */
    function toggleGridToColumnProducts() {
        jQuery(document).on("click", "a.view-grid", function () {
            jQuery(".description_column").addClass("grid");
        });
        jQuery(document).on("click", "a.view-list", function () {
            jQuery(".description_column").removeClass("grid");
        });
    }

    /**
     * Helper method for all of the JS logic for the main carousel and the thumbnails collapsable navbar on the Single Product page
     * @updated by Javier Colmenárez for GitLab #106
     */
    function sliderProduct() {
        //Single product's main carousel initialization
        jQuery(".slider-product").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            fade: true
        });
        jQuery(".slider-product").on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            jQuery(".js-zoomActionBtns.reset-zoom-btn").trigger("click");
        });
        setTimeout(function () {
            jQuery(".slider-product").slick('refresh');
        }, 2000);

        //Caching some jQuery elements for the thumbnails navbar root container and the thumbnails themselves
        var $thumbnailsContainer = jQuery('.single-product-thumbnails-container'),
            $thumbnails = jQuery('.img_item', $thumbnailsContainer);
        //Registering a click event handler on all of the real thumbnails for sliding the carousel to the related picture
        jQuery($thumbnailsContainer).on('click', '.img_item:not(.hidden)', function () {
                jQuery(".slider-product").slick('slickGoTo', $(this).attr('data-id'));
            }
        );
        /**
         * Registering a click event handler on the thumbnail with the overlay in it and the thumbnails container's collapsing button
         * for adding the collapsible CSS class and trigger the related collapsable CSS animations
         */
        jQuery(document).on('click', '.is-collapsed .has-overlay, .thumbnails-collapse-btn', function () {
            $thumbnailsContainer.toggleClass('is-collapsed');
        });
        /**
         * Creating several CSS Media Queries breakpoints for initial loading and resizing verifications, where the amount of
         * visible thumbnails will change accordingly for the collapsed thumbnails container state. Every breakpoint matching will call:
         * @function adjustSingleProductThumbnailsSection Along with a zero-based index for slicing the jQuery set of thumbnails
         */
        mediaQuery('(min-width: 1426px)', function (match) {
            if (match) {
                adjustSingleProductThumbnailsSection(5);
            }
        });
        mediaQuery('(max-width: 767px) and (min-width: 663px), (max-width: 1425px) and (min-width: 1137px)', function (match) {
            if (match) {
                adjustSingleProductThumbnailsSection(4);
            }
        });
        mediaQuery('(max-width: 662px) and (min-width: 457px), (max-width: 1136px) and (min-width: 882px)', function (match) {
            if (match) {
                adjustSingleProductThumbnailsSection(3);
            }
        });
        mediaQuery('(max-width: 456px), (max-width: 881px) and (min-width: 768px)', function (match) {
            if (match) {
                adjustSingleProductThumbnailsSection(2);
            }
        });

        /**
         * @function adjustSingleProductThumbnailsSection Helper method used for adjusting the following layout issues in the thumbnails section:
         * 1. Move the 'more items' overlay accordingly deppending on the allowed amount of thumbnails per row:
         *    In every painting process where the number of allowed thumbnails changes due to the available space within the thumbnails container
         *    it is necessary to move accordingly and update the 'more items' overlay info so it can be shown in the thumbnail at the new limit position
         * 2. Recalculate and insert some dummy elements to align accordingly the thumbnails in the last row when there is empty space:
         *    If there are empty positions in the last row of thumbnails, the Flex model will try to distribute the remaining space between the
         *    remaining thumbnails resulting in incorrect and undesired spaces between them. By inserting some invisible dummy Flex elements this
         *    is fixed and the grid layout is consistent no matter the amount of empty spaces in the last row.
         * @author Javier Colmenárez
         * @param {integer} hideFrom Zero-based index used for setting the range of selected thumbnails in several internal operations
         */
        function adjustSingleProductThumbnailsSection(hideFrom) {
            //Caching the length of the targeted thumbnails that will be hidden after the 'more items' element in the collapsed mode
            var itemsLength = $thumbnails.slice(hideFrom).length;
            //Removing the 'more items' overlay and CSS class from the previous thumbnail
            jQuery('.has-overlay', $thumbnailsContainer).removeClass('has-overlay').children('.overlay').remove();
            $('#js-single-product-carousel-nav-bar').css('justify-content', 'start');
            //Cheking if there are any thumbnails to hide after the new limit position
            if (itemsLength > 0) {
                //Getting the thumbnail at the new limit position and inserting the 'more items' overlay in it and adding the respective CSS class
                $thumbnails.slice(hideFrom - 1, hideFrom).addClass('has-overlay').prepend('<span class="overlay">+ ' + itemsLength + '</span>');
                $('#js-single-product-carousel-nav-bar').css('justify-content', 'space-around');
                //Removing the previous dummy Flex elements
                jQuery('.img_item.hidden', $thumbnailsContainer).remove();
                //Calculating the remaining thumbnails in the last row from the thumbnails total length minus and the new limit position
                var doesItNeedFlexFix = itemsLength % hideFrom;
                //Checking if there are any empty spaces to fill in the last row
                if (doesItNeedFlexFix !== 0) {
                    //Creating the required dummy Flex elements for filling up the empty positions in the last row
                    var dummyFlexElems = Array((hideFrom - doesItNeedFlexFix) + 1).join('<div class="img_item hidden"></div>');
                    //Inserting the dummy Flex elements into the thumbnails inner wrapper
                    $thumbnailsContainer.children('.thumbnails-wrapper').append(dummyFlexElems);
                }
            }
        }
    }

    function toggleGridToColumnResources() {
        //Catalog
        jQuery(document).on("click", "a.view-2-columns", function () {
            jQuery(".resource_outside").removeClass("col-md-4 col-lg-4");
            jQuery(".resouce_center__catalog .resource_outside").removeClass("col-lg-4");
            jQuery(".resource_outside").addClass("col-md-6");
            jQuery(".resource_inside").removeClass("col-md-12");
            jQuery(".info_container").addClass("info_container_grid_2");
            jQuery(".product-name").addClass("product_name_2_grid");
            jQuery(".resource_outside .resource_inside_image").addClass("col-md-7");
            jQuery(".resource_outside .info_container").removeClass("col-md-6").addClass("col-md-5");
            jQuery(".resources_manual .product_container").removeClass('one-column').addClass('two-columns');
        });
        jQuery(document).on("click", "a.view-3-columns", function () {
            jQuery(".resouce_center__catalog .resource_outside").addClass("col-lg-4");
            jQuery(".resource_outside").removeClass("col-md-6");
            jQuery(".resource_outside").addClass("col-md-4");
            jQuery(".resource_inside").addClass("col-md-12");
            jQuery(".resource_outside .resource_inside_image").removeClass("col-md-7");
            jQuery(".resource_outside .info_container").removeClass("col-md-5");
            jQuery(".info_container").removeClass("info_container_grid_2");
            jQuery(".product-name").removeClass("product_name_2_grid");
        }); //End Catalog

        //Manual
        jQuery(document).on("click", "a.resources_manual_2", function () {
            jQuery(".resources_manual").addClass("col-md-6");
        });
        jQuery(document).on("click", "a.resources_manual_1", function () {
            jQuery(".resources_manual").removeClass("col-md-6");
            jQuery(".resources_manual .product_container").removeClass('two-columns').addClass('one-column');
        });
        //End Manual

        //Media
        jQuery(document).on("click", "a.resource_center_media_1", function () {
            jQuery(".resource_center_media").removeClass("col-md-6 col-md-4");
            jQuery(".product_container").removeClass("three-columns");
            jQuery(".resource_center_media_inner").addClass("col-md-6 single-layout");
            jQuery(".resource_center_media_inner_text").addClass("d-block");
        });
        jQuery(document).on("click", "a.resource_center_media_2", function () {
            jQuery(".resource_center_media").removeClass("col-md-4");
            jQuery(".resource_center_media_inner").removeClass("col-md-6 single-layout");
            jQuery(".resource_center_media_inner_text").removeClass("d-block");
            jQuery(".product_container").addClass("three-columns");
            jQuery(".resource_center_media").addClass("col-md-6");
        });
        jQuery(document).on("click", "a.resource_center_media_3", function () {
            jQuery(".resource_center_media").removeClass("col-md-6");
            jQuery(".resource_center_media_inner").removeClass("col-md-6 single-layout");
            jQuery(".resource_center_media_inner_text").removeClass("d-block");
            jQuery(".product_container").addClass("three-columns");
            jQuery(".resource_center_media").addClass("col-md-4");
        });
        //End Media

        //Product Detail
        jQuery(document).on('click', '.js-zoomActionBtns', function (evt) {
            var action = evt.target.dataset.action,
                $sliderEl = jQuery(evt.target).parent().find('.slick-slider'),
                currSlideEl = $sliderEl.slick('getSlick').$slides[$sliderEl.slick('slickCurrentSlide')],
                imgEl = currSlideEl.firstElementChild;

            if (
                (action === 'increase' && imgEl.clientHeight >= 800) ||
                (action === 'decrease' && imgEl.clientHeight <= 100)
            ) {
                return false;
            }

            if (action === 'reset') {
                imgEl.style.height = null;
                imgEl.style.maxHeight = '300px';
            } else {
                var currHeight = imgEl.clientHeight,
                    newHeight = action === 'increase' ? currHeight + 100 : currHeight - 100;
                imgEl.style.height = [newHeight, 'px'].join('');
                imgEl.style.maxHeight = [newHeight, 'px'].join('');


                jQuery(".slider-product").slick('refresh');
            }
        });
        jQuery(document).on('click', '.CarouselModal .slick-arrow', function (evt) {
            $sliderEl = $('.CarouselModal-mainCarousel').find('.slick-slider'),
                currSlideEl = $sliderEl.slick('getSlick').$slides[$sliderEl.slick('slickCurrentSlide')],
                imgEl = currSlideEl.firstElementChild;
            imgEl.style.height = null;
            imgEl.style.maxHeight = '300px';
        });

    }

    /**
     * The helper method for scrolling to a specific section and updating the hash on the URL if needed:
     * @param {string} hash The real ID selector of the target element where the viewport will scroll to,
     * if the 'deepLink' param is not defined, is also the real hash value to be set on the URL after the scrolling is completed.
     * @param {number|undefined} extraScrolling An optional value for extra scrolling because of some overlays issues due to layout complexity.
     * @param {string|undefined} deepLink If defined, is the real hash value to be set on the URL after the scrolling is completed.
     */
    function goToSection(hash, extraScrolling, deepLink) {
        // Caching the hash value that will be set on the URL and the jQuery element with the ID attribute associated to that hash
        var realHash = deepLink || hash,
            $target = jQuery(realHash),
            // Calculating if the real offset needs some extra scrolling and caching it
            finalOffset = jQuery(hash).offset().top - (extraScrolling || 0);
        /**
         * 1. Calling the animated scrolling on both the HTML and BODY elements (resulting in calling twice the animation callback)
         * 2. Chaining with the 'Promise' API in order to call only once the animation callback
         * 3. Checking if current URL hash is the same as the one about to set and returning
         * 4. Temporally removing the ID attribute of the associated element in order to avoid the viewport jumping back to its offset
         *    when updating the hash in the URL. After that hash change event, setting back again the ID value to the associated element.
         *  */
        jQuery('html, body').animate({scrollTop: finalOffset}, 800).promise().done(function () {
                if (window.location.hash === realHash) {
                    return;
                }
                $target.attr('id', '');
                window.location.hash = realHash;
                $target.attr('id', realHash.replace(/^#/, ''));
            }
        );
    }

    /*(7) Contact Form Handler
           =================================================== */
    function contactFormHandler() {
        jQuery(function ($) {
            if ($("body.contact").length > 0) {
                $(document).on("submit", "#contact-form", function (e) {
                    e.preventDefault();

                    var form = $(this);
                    var btn = $(".btn_form_submit", form);

                    btn.button("loading");
                    deleteFormErrors(form);
                    $.ajax({
                        url: admin_url.ajax_url,
                        type: "post",
                        dataType: "json",
                        data: form.serialize() + "&action=send_contact_form"
                    })
                        .done(function (response) {
                            if (response.valid) {
                                form.slideUp(function () {
                                    $("#contact-confirm").show();
                                });
                                var offset = $("#site-header").height();
                                $("html, body").animate(
                                    {
                                        scrollTop:
                                            $("section.contact_us .contact_us__title").offset().top -
                                            offset
                                    },
                                    "slow"
                                );
                            } else {
                                showFormErrors(response.errors, response.msg, form);
                            }
                            btn.button("reset");
                        })
                        .fail(function (error) {
                            btn.button("reset");
                        });
                });

                function showFormErrors(errors, msg, form) {
                    if (errors) {
                        $.each(errors, function (input, error) {
                            var formgroup = $(`.form-control[name='${input}']`, form).closest(
                                ".form-group"
                            );
                            formgroup.addClass("error");
                            formgroup.append(`<small class="label-error">${error}</small>`);
                        });
                    }
                    if (msg) {
                        $(".div_form_errors", form).html(
                            `<span class="required_fields_text">${msg}</span>`
                        );
                    }
                }

                function deleteFormErrors(form) {
                    $(".form-group", form).removeClass("error");
                    $(".form-group small.label-error", form).remove();
                    $(".div_form_errors", form).html(``);
                }
            }
        });
        jQuery.fn.button = function (action = "") {
            if (action == "") {
                return;
            }
            switch (action) {
                case "loading":
                    var loadingText = $(this).attr("data-loading-text")
                        ? $(this).attr("data-loading-text")
                        : "Please wait..";
                    $(this).prop("disabled", true);
                    $(this).addClass("disabled");
                    $(this).attr("data-original-text", $(this).html());
                    $(this).html(loadingText);
                    break;
                case "reset":
                    $(this).prop("disabled", false);
                    $(this).removeClass("disabled");
                    $(this).html($(this).attr("data-original-text"));
                    break;
            }
        };
    }

    /*(8) Warranty Claim Form Handler
           =================================================== */
    function warrantyFormHandler() {
        jQuery(function ($) {
            $(document).on("submit", "#warranty-claim-form", function (e) {
                e.preventDefault();

                var form = $(this);
                var btn = $(".btn_form_submit", form);

                btn.button("loading");
                deleteFormErrors(form);
                $.ajax({
                    url: admin_url.ajax_url,
                    type: "post",
                    dataType: "json",
                    data: form.serialize() + "&action=send_warranty_claim_form"
                })
                    .done(function (response) {
                        if (response.valid) {
                            console.log(response);
                            form.slideUp(function () {
                                $("#contact-confirm").show();
                            });
                            var offset = $("#site-header").height();
                            $("html, body").animate(
                                {
                                    scrollTop:
                                        $("section.contact_us .contact_us__title").offset().top -
                                        offset
                                },
                                "slow"
                            );
                        } else {
                            showFormErrors(response.errors, response.msg, form);
                        }
                        btn.button("reset");
                    })
                    .fail(function (error) {
                        btn.button("reset");
                    });
            });

            function showFormErrors(errors, msg, form) {
                if (errors) {
                    $.each(errors, function (input, error) {
                        var formgroup = $(`.form-control[name='${input}']`, form).closest(
                            ".form-group"
                        );
                        formgroup.addClass("error");
                        formgroup.append(`<small class="label-error">${error}</small>`);
                    });
                }
                if (msg) {
                    $(".div_form_errors", form).html(
                        `<span class="required_fields_text">${msg}</span>`
                    );
                }
            }

            function deleteFormErrors(form) {
                $(".form-group", form).removeClass("error");
                $(".form-group small.label-error", form).remove();
                $(".div_form_errors", form).html(``);
            }
        });

        jQuery.fn.button = function (action = "") {
            if (action == "") {
                return;
            }
            switch (action) {
                case "loading":
                    var loadingText = $(this).attr("data-loading-text")
                        ? $(this).attr("data-loading-text")
                        : "Please wait..";
                    $(this).prop("disabled", true);
                    $(this).addClass("disabled");
                    $(this).attr("data-original-text", $(this).html());
                    $(this).html(loadingText);
                    break;
                case "reset":
                    $(this).prop("disabled", false);
                    $(this).removeClass("disabled");
                    $(this).html($(this).attr("data-original-text"));
                    break;
            }
        };
    }

    /*(9) Mobile menu
         =================================================== */

    /*function mobileMenu() {

          var $windowSize = jQuery(window).width();

          if($windowSize < 768){

            jQuery('.turbo-air__sub_navbar').addClass('collapse');
            jQuery('.turbo-air__header').append(jQuery('.turbo-air__sub_navbar').detach());

          }

    }*/

    /*(10) Video Modal
           =================================================== */

    function videoModal() {
        jQuery('.see_more_video_placeholder, .featured_product_video_placeholder, .innovation_video_placeholder, .resource_media_video_placeholder').on('click', function () {
            var cloneVideoContent = jQuery(this).clone(true);
            if (cloneVideoContent.hasClass('resource_media_video_placeholder')) {
                cloneVideoContent.addClass('embed-responsive embed-responsive-16by9');
            }
            cloneVideoContent.find(".see_more_video_thumbnail").remove();
            jQuery('.modal-content').empty().append(cloneVideoContent);
            jQuery('#videoModal').modal('toggle');
        });
        jQuery("#videoModal").click(function () {
            // changes the iframe src to prevent playback or stop the video playback in our case
            $(this).find('.modal-content').empty();
            $(this).modal('hide');
            //console.log('click');
            return false;
        });
    }

    return {
        showBrandsPopup: showBrandsPopup,
        hideBrandsPopup: hideBrandsPopup,
        topProducts: topProducts,
        relatedPartsCarousel: relatedPartsCarousel,
        headerFixedBg: headerFixedBg,
        backToTopBtn: backToTopBtn,
        homeSliderHandler: homeSliderHandler,
        toggleActiveColorTabs: toggleActiveColorTabs,
        toggleGridToColumnProducts: toggleGridToColumnProducts,
        goToSection: goToSection,
        contactFormHandler: contactFormHandler,
        warrantyFormHandler: warrantyFormHandler,
        //mobileMenu: mobileMenu,
        videoModal: videoModal,
        toggleGridToColumnResources: toggleGridToColumnResources,
        sliderProduct: sliderProduct
    };
})();

/**
 * Helpful method for creating CSS Media Query breakpoints and registering change events listeners in order to apply changes respectively
 * @param {string} query A CSS Media Query expression to match
 * @param {function} callback A function to be executed once just when creating the MediaQueryList object and
 * whenever the CSS Media Query expression is matched on a viewport change event
 * Callback Params:
 *    @param {boolean} matches From either [mediaQueryList / mediaQueryListEvent] it represents the CSS Media Query matching state
 *    @param {string} media The original CSS Media Query value
 */
function mediaQuery(query, callback) {
    var mediaQueryList = window.matchMedia(query);
    callback.apply(null, [mediaQueryList.matches, mediaQueryList.media]);
    mediaQueryList.addListener(function (mediaQueryListEvent) {
        callback.apply(null, [mediaQueryListEvent.matches, mediaQueryListEvent.media]);
    });
}

/**
 * Registering a click event handler on the links in the 'Warranty Support' banner in order to trigger the already bound tabs navigation
 * This due to an issue with the regular Bootstrap implementation where more than one tab button handling the same tab pane break the nav flow
 * */
jQuery(document).on('click', '.js-warranty-links-to-tabs', function (evt) {
    evt.preventDefault();
    // Triggering the tab nav logic on the originally bound tab element
    jQuery([this.hash, '-warranty-tab'].join('')).tab('show');
});

/**
 /**
 * Extending this 'goToSection' callback implementation with some extra params given that when the scrolling reached
 * the target element's top offset, the scrolling was insufficient leaving the target element behind the sticky menus.
 * With these optional params the callback's original logic is preserved and enhanced only when needed.
 */
jQuery(document).on("click", ".go-to-section", function (e) {
    // Caching the data-set values from the clicked element and calling the scrolling method with that info
    e.preventDefault();
    var data = jQuery(this).data(),
        headerH = $('.turbo-air__header').height(),
        navH = $('.turbo-air__sub_navbar.sticky').height(),
        hash = data.link,
        extraScrolling = (headerH || 0) + (navH || 0) + 40,
        deepLink = data.deeplink;
    custom_js_theme.goToSection(hash, extraScrolling, deepLink);
});

// Refining the click event handler that opens the Brands popover to work only in mobile container
jQuery(document).on("click", ".mobile-nav .show-brands", function () {
    custom_js_theme.showBrandsPopup();
});
// Improving the Brands popover's closing logic from the click event on the 'X' icon within it.
jQuery(document).on("click", ".hide-brands", function (evt) {
    // Checking for the regular size popover container and...
    if ($('li.opened #brands-header-container')) {
        $('li.opened #brands-header-container').remove();
        jQuery(this).removeClass('opened');
    }
    var selector = jQuery(".brands-container");
    selector.css("display", "none");
});

jQuery(document).on("click", "#turbo-air_top_products .see-all-products-series .btn.cta, #turbo-air_top_products .see-all-products-series .collapse-products.opened", function (event) {
    event.preventDefault();
    custom_js_theme.topProducts($(this));
});

/*Doc Ready*/
jQuery(document).ready(function () {
    /**
     * HEADER FIXES
     * 1. [CSS purposes node relocation] Cloning brands popover container, updating its ID attribute and moving it next to the 'Brands' header's menu link
     */
    // 2. [CSS purposes node relocation] Identifying the closing 'X' for the recently cloned brands popover and moving the top little arrow out to the popover container
    // 3. Adding a hover-in event listener to the LI parent element of the 'Brands' header's menu link for adding a CSS class and ensure its forced display when hovering out of it
    jQuery('a.show-brands').parent('li.nav-item').on('click', function (evt) {

        if (jQuery(this).attr('class').includes('opened') === false) {

            jQuery(this).addClass('opened');
            jQuery('#o-brands-header-container')
                .clone()
                .attr('id', 'brands-header-container')
                .insertAfter('.opened a.show-brands');

            jQuery('#brands-header-container').find('.hide-brands').addClass('js-hide-brands').end().find('.arrow').prependTo('#brands-header-container');
            jQuery('li.opened #brands-header-container .brands-container').css("display", "block");
        } else {

            jQuery('li.opened #brands-header-container').remove();
            jQuery('li.nav-link .turbo-air__header__brands').each(function () {
                $(this).remove();
            });
            if ($('li.opened #brands-header-container')) {
                $('li.opened #brands-header-container').remove();
                jQuery(this).removeClass('opened');
            }
            var selector = jQuery(".brands-container");
            selector.css("display", "none");
            jQuery(this).removeClass('opened');

        }
    });
    // 4. Adding a hash value to the HREF URL value of the 'Technology' header's menu link in order to enable the deep link that will show its respective tab when navigating to it
    var $turboAirTechDeepLink = jQuery('#site-header .nav-link[href*="why-turbo-air"]');
    $turboAirTechDeepLink.attr('href', [$turboAirTechDeepLink.attr('href'), '#technology'].join(''));
    // 5. Verifying when loading the page if it is the 'Why Turbo Air?' page and if does it have the deep link hash value in order to show the proper tab
    if (jQuery('body').hasClass('why-turbo-air') && document.location.hash && document.location.hash === '#technology') {
        jQuery('.nav-link.company_profile_tab[href="#technology"]').tab('show');
    }
    // 6. Binding a click event handler to the mobile menu buttons in order to show/hide the main mobile menu
    jQuery('button.open-menu-btn', '#site-header').on('click', function (evt) {
        jQuery('.mobile-nav .menu-sidebar').addClass('active');
    });
    jQuery('button.close-menu-btn', '.mobile-nav').on('click', function (evt) {
        jQuery(this).parent('.menu-sidebar').removeClass('active');
    });

    jQuery(".turbo-air-slider").slick({
        dots: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        pauseOnHover: false,
        autoplay: true,
        adaptiveHeight: true,
        autoplaySpeed: 9000
    });
    jQuery(".turbo-air-slider .slick-dots").append(
        '<a id="slick-pause" href="#"><i class="fas fa-pause"></i></a>'
    );
    jQuery(".turbo-air-slider .slick-dots").append(
        '<a id="slick-play" href="#"><i class="fas fa-play"></i></a>'
    );

    jQuery("#status-warranty-tab").click(function () {

            var currSrc = jQuery("#status .row iframe").attr("src");
            console.log(currSrc);
            jQuery("#status .row iframe").attr("src", currSrc);
        if (!jQuery(this).hasClass('active')) {
        }
    });


    jQuery(".new_released_slider").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: false,
        autoplay: false,
        autoplaySpeed: 5000,
        arrows: true,
        prevArrow: '<div class="new_released_slider_left_arrow_container"><button type="button" class="slick-prev"></button></div>',
        nextArrow: '<div class="new_released_slider_right_arrow_container"><button type="button" class="slick-next"></button></div>',
        variableWidth: true,
        responsive: [
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
    jQuery(".FullWidthCarousel-slider").slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        pauseOnHover: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        //Adding a selector to use target elems as the nav arrows and ensure responsiveness according to design
        prevArrow: '.FullWidthCarousel-navBtn--prev',
        nextArrow: '.FullWidthCarousel-navBtn--next',
        variableWidth: true,
        //ToDo: Improve this responsive logic for the arrows and the slides to show in some breakpoints
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 736,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 484,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.new_released_product_gallery').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: false,
        draggable: false
    });

    $('.img-box > a').on('click', function (e) {

        if ($(e.target).is(":button")) {
            e.preventDefault();
            e.stopPropagation();
        }
    })

    jQuery(document).on("click", ".related-parts-carousel .FullWidthCarousel-footerBtn, .related-parts-carousel .collapse-products.opened", function (event) {
        event.preventDefault();
        custom_js_theme.relatedPartsCarousel($(this));
    });

    /**
     * Carousel Modal Component
     * Bootstrap based modal with a main single-image fading carousel and a synced navigation carousel with its thumbnails
     * @author Javier Colmenárez
     * @namespace {object} __CAROUSEL_MODAL Holds the carousels configuration objects and some modal-related control variables
     * @prop {object} mainSliderConfig Main carousel config (Will show 1 slide at a time using fading FX)
     * @prop {object} navBarSliderConfig Thumbnails navigation carousel config (Will show 8 slides at a time, scrolling by one)
     * @prop {null | jQuery Element} prevModal Cached reference to the modal's jQuery element
     * @prop {string} prevModalIdSelector Cached reference to the modal's ID selector
     * @prop {boolean} isRerendering Control variable for reusing a previously saved modal element or creating a new one
     */
    var __CAROUSEL_MODAL = {
        mainSliderConfig: {
            asNavFor: '.js-CarouselModal-navBar',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '.CarouselModal-mainNavBtns--prev',
            nextArrow: '.CarouselModal-mainNavBtns--next',
            infinite: true,
            fade: true
        },
        navBarSliderConfig: {
            asNavFor: '.js-CarouselModal',
            infinite: true,
            slidesToShow: 8,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '.CarouselModal-navBarBtns--prev',
            nextArrow: '.CarouselModal-navBarBtns--next',
            variableWidth: true,
            focusOnSelect: true
        },
        prevModal: null,
        prevModalIdSelector: null,
        isRerendering: false
    };
    /**
     * Listening to the click event for the related buttons will clone all of the content needed by the carousels in the modal
     * and inject it accordingly in the modal's placeholders to show the modal properly loaded and init its sliders
     */
    jQuery('.js-SingleProductCarousel-actionBtns--expand, .js-ExternalAds-actionsBtns--expand').on('click', function (evt) {
        // Accessing the clicked button element and its config data
        var btn = evt.target,
            config = JSON.parse(btn.dataset.carouselModal);

        // Checking if current modal is the same as the previous one in order to re-render or process new content
        if (__CAROUSEL_MODAL.prevModal !== null && __CAROUSEL_MODAL.prevModal.attr('id') === config.modal) {
            // Reusing the previously created modal instance (jQuery Element)
            var $targetModal = __CAROUSEL_MODAL.prevModal;
            // Setting the re-rendering flag on so upcoming flow is aware of re-rendering process
            __CAROUSEL_MODAL.isRerendering = true;
        } else {
            // Setting the re-rendering flag off so upcoming flow is aware of a brand new process
            __CAROUSEL_MODAL.isRerendering = false;
            // Saving for cached use the CSS query modal ID selector
            __CAROUSEL_MODAL.prevModalIdSelector = ['#', config.modal].join('');

            /** Caching jQuery elements for the modal and the cloned slides from the main and the thumbnails navigation carousels
             * The cloned slides excludes the Slick's cloned items within the carousels assuring to get only the original items */
            var $targetModal = jQuery(__CAROUSEL_MODAL.prevModalIdSelector),
                $clonedMainSliderItems = jQuery('.js-slide-item:not(.slick-cloned)', ['#', config.main].join('')).clone(true),
                $clonedNavBarItems = jQuery('.js-slide-item:not(.slick-cloned)', ['#', config.nav].join('')).clone(true);

            // Cleaning up styles and data attributes as well as removing any Slick's based CSS classes from the cloned slides
            $clonedMainSliderItems.removeAttr('style tabindex aria-hidden data-slick-index').removeClass('slick-slide slick-current slick-active');
            $clonedNavBarItems.removeAttr('style tabindex aria-hidden data-slick-index').removeClass('slick-slide slick-current slick-active');

            // Injecting cleaned-up carousels items in the modal's placeholders
            $targetModal.find('.js-CarouselModal').empty().append($clonedMainSliderItems);
            $targetModal.find('.js-CarouselModal-navBar').empty().append($clonedNavBarItems);
        }

        // Initializing the carousels in the modal using their respective configs
        $targetModal.find('.js-CarouselModal').slick(__CAROUSEL_MODAL.mainSliderConfig);
        $targetModal.find('.js-CarouselModal-navBar').slick(__CAROUSEL_MODAL.navBarSliderConfig);

        // Showing the modal
        $targetModal.modal('show');

        // Registering modal's events listeners only once, specifically during a brand new process
        if (__CAROUSEL_MODAL.prevModal === null) {
            /** When the modal has been completely shown, forcing a re-render on the main carousel
             * due to an issue where the first slide wasn't being properly shown until any carousel's navigation was executed */
            $targetModal.on('shown.bs.modal', function (evt) {
                $targetModal.find('.js-CarouselModal').slick('unslick').slick('reinit').slick(__CAROUSEL_MODAL.mainSliderConfig);
            });
            // When the modal has been completely hidden, destroying the carousels instances
            $targetModal.on('hidden.bs.modal', function (evt) {
                $targetModal.find('.js-CarouselModal').slick('unslick');
                $targetModal.find('.js-CarouselModal-navBar').slick('unslick');
            });
        }

        // Storing the current modal jQuery Element for upcoming reusing when needed
        if (__CAROUSEL_MODAL.prevModal === null || __CAROUSEL_MODAL.prevModal.attr('id') !== config.modal) {
            __CAROUSEL_MODAL.prevModal = $targetModal;
        }
    });

    /**
     * Helper function to reset zoom changes on carousel's current image
     * @param {object} slick Carousel internal config object
     * @param {number} currSlide Zero-based index position for the carousel's current slide
     */
    function resetProductDetailsPicsZoomLevel(slick, currSlide) {
        jQuery(slick.$slides[currSlide]).find('img').each(function () {
            this.style.height = null;
        });
    }

    /**
     * Listening when the carousels attempt to change its slides and resetting the zoom changes on any carousel picture
     * @event beforeChange Carousel custom event triggered just before the slide changes
     * @param {event} evt Event custom object
     * @param {object} slick Carousel internal config object
     * @param {number} currSlide Zero-based index position for the carousel's current slide
     */
    jQuery(document).on('beforeChange', '.slick-slider', function (evt, slick, currSlide) {
        resetProductDetailsPicsZoomLevel(slick, currSlide);
    });
    /**
     * End of Carousel Modal Component logic
     */


    /**
     * Sticky secondary menu navbar & mega menu dropdown when hovering on Products menu item
     * @author Javier Colmenárez
     * @namespace {object} __STICKY_AND_MEGAMENU Holds the cached values for heights and vertical offsets as well as for jQuery Elements needed for reusing over and over later
     * @prop {array} stickyPages Holds the list of pages where the sticky menu will be activated
     * @prop {jQuery Element} $headerBar Cached reference to main header jQuery element
     * @prop {jQuery Element} $menuBar Cached reference to secondary navbar jQuery element
     * @prop {function} menuBarTop Cached value for secondary navbar's top offset
     * @prop {number} stickyBarsHeights Cached value for the sum of the heights of the main header plus the secondary navbar elements
     * @prop {jQuery Element} $productsMenuItem Cached reference to the 'Products' menu item jQuery Element in the secondary navbar
     */
    var __STICKY_AND_MEGAMENU = {
        stickyPages: [
            // products, product-category
            'archive',
            // single-product
            'single-product',
            /**
             * home, news-event, compare, contact, privacy-policy, terms-conditions, california-supply-chains-act, warranty, sales-network,
             * order-status-check, resource-center-catalog, resource-center-manual, resource-center-media-archives, resource-center-ads, why-turbo-air
             *  */
            'page-template'
        ],
        singleProduct: [
            'single-product'
        ],
        $headerBar: jQuery('.turbo-air__header'),
        $menuBar: jQuery('#turbo-air_sub_navbar'),
        $menuSingleProduct: jQuery('.features_nav'),
        menuBarTop: function () {
            return __STICKY_AND_MEGAMENU.$menuBar.prev(':not(.CompareBtn)').outerHeight() - __STICKY_AND_MEGAMENU.$menuBar.outerHeight()
        },
        menuSingleProductTop: function () {
            return __STICKY_AND_MEGAMENU.$menuSingleProduct.prev(':not(.CompareBtn)').outerHeight() + __STICKY_AND_MEGAMENU.$menuSingleProduct.outerHeight() + __STICKY_AND_MEGAMENU.$headerBar.outerHeight()
        }
    };
    __STICKY_AND_MEGAMENU['stickyBarsHeights'] = __STICKY_AND_MEGAMENU.$headerBar.outerHeight() + __STICKY_AND_MEGAMENU.$menuBar.outerHeight();
    __STICKY_AND_MEGAMENU['$productsMenuItem'] = __STICKY_AND_MEGAMENU.$menuBar.find('a').filter(function () {
        return this.innerHTML === 'Products';
    });

    /**
     * Helper to calculate remaining vertical space in viewport after main header and secondary navbar have been set as sticky elems
     * in order to assign this remaining vertical space as the maximun height of the expanded mega menu and make it scrollable if needed
     */
	function makeMegaMenuScrollableIfNeeded() {
        // Calculating and caching the value of the available vertical space for the mega menu height
        var remainingVSpaceForMegaMenu = window.innerHeight - __STICKY_AND_MEGAMENU.stickyBarsHeights,
            // Getting and caching the mega menu jQuery Element
			megaMenu = jQuery('.MegaMenu'),
			menuGroupMaxHeight = 400,
			columnCount = $('.MegaMenu__inner').css('column-count'),
			totalH = 0;

		// getting the full height of the biggest menu group
		$('.MegaMenu-itemsGroup').each(function(){
			var thisH = $(this).outerHeight(true);
			totalH += thisH;
			if (thisH > menuGroupMaxHeight) { menuGroupMaxHeight = thisH; }
		});

		// if the number of groups is <= the number of columns then we reduce the height to force them to balance
		if ($('.MegaMenu-itemsGroup').length <= columnCount ) {
			megaMenu.css({
				// overflow doublechecks if there is enough space to display
				'overflow': (remainingVSpaceForMegaMenu < menuGroupMaxHeight) ? 'auto' : 'unset',
				'max-height': [(menuGroupMaxHeight + 25), 'px'].join('')
			});
		// if the total height of all group wonts reach the last column then we reduce the menu height to force them to balance
		} else if ( totalH < ( ( columnCount - 1 ) * megaMenu.outerHeight() ) && totalH < (columnCount * menuGroupMaxHeight) ) {
			megaMenu.css({
				// overflow doublechecks if there is enough space to display
				'overflow': (remainingVSpaceForMegaMenu < menuGroupMaxHeight) ? 'auto' : 'unset',
				'max-height': [(menuGroupMaxHeight + 50), 'px'].join('')
			});
		// Otherwise we verify that the remaining space can accommodate the unrestricted menu
		} else if (remainingVSpaceForMegaMenu <= megaMenu.outerHeight()) {
            megaMenu.css({
                'overflow': 'auto',
				'max-height': [remainingVSpaceForMegaMenu, 'px'].join('')
            });
   		// Otherwise, remove all of the style changes
		} else {
            megaMenu.removeAttr('style');
		}
    }

    /**
     * Helper to make the secondary navbar sticky after the main header sticky element, by checking if the current viewport vertical offset
     * plus the main header height have reached the top offset of the secondary navbar, if so then it makes it an sticky element
     */
    function toggleStickyClass() {
        if ((window.pageYOffset + __STICKY_AND_MEGAMENU.$headerBar.outerHeight()) >= __STICKY_AND_MEGAMENU.menuBarTop()) {
            __STICKY_AND_MEGAMENU.$menuBar.addClass('sticky');
        } else {
            // Otherwise, it comes back to its regular layout flow
            __STICKY_AND_MEGAMENU.$menuBar.removeClass('sticky');
        }
    }

    function toggleStickyClassSingleProduct() {
        if ((window.pageYOffset + __STICKY_AND_MEGAMENU.$menuBar.outerHeight()) >= __STICKY_AND_MEGAMENU.menuSingleProductTop()) {
            __STICKY_AND_MEGAMENU.$menuSingleProduct.addClass('sticky');
        } else {
            // Otherwise, it comes back to its regular layout flow
            __STICKY_AND_MEGAMENU.$menuSingleProduct.removeClass('sticky');
        }
    }

    /**
     * Applying the sticky styles set to the secondary menu when the page is enabled for it, and either the user scrolls or loads the page
     * @callback mediaQuery Reference to the CSS Media Queries helper method for creating the viewport breakpoint that will be checked
     * during the initial load of the page and when the user resizes the viewport, in order to recalculate the secondary menu top offset,
     * enable/disable the sticky styles set and attach/detach the Scroll event listeners bound to the sticky helper method
     * @callback toggleStickyClass Reference to the sticky helper function
     * @event onscroll User scrolling up and down the page
     * */
    if (__STICKY_AND_MEGAMENU.stickyPages.filter(function (className) {
        return document.body.classList.contains(className);
    }).length > 0) {
        mediaQuery('(max-width: 767px)', function (match) {
            if (!match) {
                toggleStickyClass();
                jQuery(window).on('scroll', toggleStickyClass);
            } else {
                jQuery(window).off('scroll', toggleStickyClass);
                __STICKY_AND_MEGAMENU.$menuBar.removeClass('sticky');
            }
        });
    }
    if (__STICKY_AND_MEGAMENU.singleProduct.filter(function (className) {
        return document.body.classList.contains(className);
    }).length > 0) {
        mediaQuery('(max-width: 767px)', function (match) {
            if (!match) {
                toggleStickyClassSingleProduct();
                jQuery(window).on('scroll', toggleStickyClassSingleProduct);
            } else {
                jQuery(window).off('scroll', toggleStickyClassSingleProduct);
                __STICKY_AND_MEGAMENU.$menuSingleProduct.removeClass('sticky');
            }
        });
    }
    /**
     * 1. Moving the mega menu DOM element next to the 'Products' menu item anchor element
     *      (this due to PHP content generation restrictions to include it from there)
     * 2. Setting several attributes to the 'Products' menu item anchor element needed for the Bootstrap's dropdown component
     * 3. Applying some CSS classes to the LI element (parent of both anchor and mega menu elems) needed by the Bootstrap's dropdown component
     * 4. Registering a hover event handler event for the LI element in order to trigger the showing and hidding of the dropdown mega menu
     * 5. Registering a click event handler for the 'Products' menu item anchor element to avoid Bootstrap's dropdown click handler allowing regular navigation
     */
    __STICKY_AND_MEGAMENU.$productsMenuItem.after([jQuery('.MegaMenu').get(0).previousSibling.previousSibling, jQuery('.MegaMenu'), jQuery('.MegaMenu').get(0).nextSibling.nextSibling]).attr({
        'aria-haspopup': true,
        'aria-expanded': false,
        'data-reference': 'parent',
        'data-toggle': 'dropdown',
        'id': 'products-mega-menu'
    }).parent('li').addClass('MegaMenu-triggerContainer dropdown').hover(function (evt) {
        // Checking for minimal responsive breakpoint, otherwise returning out of the callback w/o showing the mega menu
        if (jQuery(document).outerWidth() <= 992) {
            return false;
        }
        // Showing the dropdown mega menu
        jQuery('.MegaMenu').dropdown('show');
    }, function (evt) {
        // Hiding the dropdown mega menu
        jQuery('.MegaMenu').dropdown('hide');
    });
    jQuery('.MegaMenu-triggerContainer > a').on('click', function (evt) {
        // Preventing the click event propagation up to the DOCUMENT node where the Bootstrap's dropdown click event binding was done
        evt.stopPropagation();
    });

    jQuery('.MegaMenu.dropdown-menu a').on('click', function (evt) {
        window.location = $(this).attr('href');
    });
    /**
     * Listening to the mega menu dropdown showing and hiding events in order to verify if it needs to be scrollable or not
     * @event hidden.bs.dropdown When the mega menu dropdown has been completely hidden
     * @event shown.bs.dropdown When the mega menu dropdown has been completely shown
     */
    jQuery('.MegaMenu-triggerContainer.dropdown').on('hidden.bs.dropdown', function (evt) {
        jQuery('.MegaMenu').removeAttr('style');
    });
    jQuery('.MegaMenu-triggerContainer.dropdown').on('shown.bs.dropdown', function (evt) {
        makeMegaMenuScrollableIfNeeded();
    });
    /**
     * End of Sticky secondary menu navbar & mega menu dropdown when hovering on Products menu item
     */


    // Product Navigation Expand
    jQuery(document).on(
        "click",
        ".product_category_sidebar_nav ul.navigation li > span",
        function (event) {
            event.preventDefault();
            if (jQuery(this).text() === "-") {
                jQuery(this)
                    .prev()
                    .siblings(".sub-category")
                    .toggle();
                jQuery(this).text("+");
                jQuery(this).css("color", "#80b66c");
            } else {
                jQuery(this)
                    .prev()
                    .siblings(".sub-category")
                    .toggle();
                jQuery(this).text("-");
                jQuery(this).css("color", "#cb6565");
            }
        }
    );


    $(".product_category_sidebar_nav .navigation .sub-category:not(:has(*))").each(function () {
        $(this).siblings('span').css('display', 'none');
    });


    // $('.single-product #features .last').each(function() {
    //     var html = $(this).html();
    //     var word = html.substr(0, html.indexOf(" "));
    //     var rest = html.substr(html.indexOf(" "));
    //     $(this).html(rest).prepend($("<span/>").html(word).addClass("em"));
    // });

    // Product Navigation Selection
    jQuery(document).on(
        "click",
        ".product_category_sidebar_nav ul.navigation li > a",
        function (event) {
            jQuery('.product_category_sidebar_nav ul.navigation li > a').removeClass("active").css("background-color", "transparent");
            if (jQuery(this).hasClass("active")) {
                jQuery(this).css("background-color", "transparent");
                // jQuery(this).removeClass("active");
            } else {
                jQuery(this).addClass("active");
                jQuery(this).css("background-color", "#d3e2eb");
            }
        }
    );

    // News: Fold/Unfold
    jQuery(document).on("click", ".news_and_events_post .fold-unfold", function (
        event
    ) {
        event.preventDefault();
        jQuery(this)
            .parent()
            .parent()
            .find(".news_and_events_post__post_content")
            .slideToggle();
        if (jQuery(this).hasClass("active")) {
            jQuery(this).removeClass("active");
        } else {
            jQuery(this).addClass("active");
        }
    });

    custom_js_theme.backToTopBtn();
    custom_js_theme.sliderProduct();
    custom_js_theme.headerFixedBg();
    custom_js_theme.homeSliderHandler();
    custom_js_theme.toggleActiveColorTabs();
    custom_js_theme.toggleGridToColumnProducts();
    custom_js_theme.contactFormHandler();
    custom_js_theme.warrantyFormHandler();
    //custom_js_theme.mobileMenu();
    custom_js_theme.videoModal();
    custom_js_theme.toggleGridToColumnResources();
});

function ajaxCompare() {
    jQuery(document).ready(function () {
        function tooltipCount(count) {
            if (count <= 1) {
                $('.btn.link-btn').attr('data-original-title', 'You must add minimum 2 products');
            } else {
                $('.btn.link-btn').attr('data-original-title', 'Go to the compare page');
            }
        }

        $('.add-to-compare').popover({
            animated: 'fade',
            placement: 'bottom',
            content: 'You can only compare up to 5 products',
            trigger: 'click'
        });
        $('.add-to-compare').popover('disable');
        /**
         * Adding / Removing products to and from the 'Compare products' browser's cookies-based local store
         * Improving the logic for showing/highlighting the added-to-compare products both for initial loading and user interactions
         * @updated by Javier Colmenárez
         * @var {string} compareCookie Initial cached cookie reference for the products comparison list
         * @var {array} compareArray Cached reference for all the products currently added to the comparison process
         */
        var compareCookie = getCookie('compare'),
            compareArray = compareCookie ? JSON.parse(compareCookie) : [];

        /**
         * @function updateCompareProductsComponent Helper method used for toggling the 'Compare Products' component and updating its counter
         * @author Javier Colmenárez
         * @param {number} count Counter for amount of products to compare
         * @param {string} method Flag for add or remove the CSS class that hides or shows the component
         */
        function updateCompareProductsComponent(count, method) {
            tooltipCount(count);
            jQuery('.CompareBtn')[method === 'hide' ? 'addClass' : 'removeClass']('d-none').parent()[method !== 'hide' ? 'addClass' : 'removeClass']('CompareBtn-isVisible').end().find('.badge').text(count);
        }

        /**
         * @relocateCompareProductsComponent Helper method for moving the compare button and adjusting the respective UI CSS classes
         * @author Javier Colmenárez
         * @param {string}  target  CSS selector for getting the target element where the compare button will be inserted
         */
        function relocateCompareProductsComponent(target, position) {
            jQuery('.contains-CompareBtn').removeClass('contains-CompareBtn CompareBtn-isVisible');
            var $container = !position ? jQuery(target) : jQuery(target).parent();
            $container.addClass('contains-CompareBtn' + (compareArray.length > 0 ? ' CompareBtn-isVisible' : ''));
            jQuery(target)[!position ? 'append' : position](jQuery('.CompareBtn').detach());
        }

        if (jQuery('.CompareBtn').length === 0) {
            jQuery('#site-header').append('<div class="CompareBtn btn-group d-none"><a class="btn link-btn" href="/compare" title="You must add minimum 2 products" data-toggle="tooltip">Compare <span>products </span><span class="badge">0</span></a><button type="button" class="close btn" aria-label="Close" title="Remove all" data-toggle="tooltip" data-placement="right"><span aria-hidden="true">&times;</span></button></div>');
        }
        // Relocating Compare Products component according to viewport's available width and adding/removing the respective CSS classes
        mediaQuery('(min-width: 1520px), (max-width: 992px) and (min-width: 768px)', function (match, query) {
            if (match) {
                relocateCompareProductsComponent('#turbo-air_sub_navbar');
            }
        });
        mediaQuery('(max-width: 1519px) and (min-width: 993px)', function (match, query) {
            if (match) {
                relocateCompareProductsComponent('#site-header');
            }
        });
        mediaQuery('(max-width: 767px)', function (match, query) {
            if (match) {
                relocateCompareProductsComponent('#turbo-air_sub_navbar', 'before');
            }
        });
        // Checking the comparison list for previously saved products
        if (compareArray.length > 0) {
            // Update the component counter and show it
            updateCompareProductsComponent(compareArray.length, 'show');
            /**
             * @var {object} productsMapObj Object that will hold jQuery elements mapped to their repective product IDs
             * @var {array} productsIDs List of every product ID shown in the current pagination view
             * @var {array} productsAlreadyInTheComparisonList  List of intersected product IDs already saved in the comparison list
             */
            var productsMapObj = {},
                productsIDs = jQuery('.add-to-compare').map(function () {
                    // Caching the current product ID
                    var id = this.dataset.product;
                    // Mapping the ID to the jQuery element in the view in the global shared reference
                    productsMapObj[id] = jQuery(this);
                    // Returning the ID as an integer instead of a string value
                    return +id;
                    // Flattening to a regular array the resulting jQuery array of elements
                }).get(),
                productsAlreadyInTheComparisonList = compareArray.filter(function (id) {
                    // Looking in the current pagination for the previously saved products IDs from the browser's cookies store
                    return productsIDs.indexOf(id) !== -1;
                });
            // Show if there are products in the current pagination page that are saved in the cookie store
            if (productsAlreadyInTheComparisonList.length > 0) {
                jQuery.each(productsAlreadyInTheComparisonList, function (i, id) {
                    // Highlight the products already saved from the rest in the current pagination page and update its action copy text
                    productsMapObj[id].parents('.product_container').addClass('added-to-compare').end().get(0).childNodes[0].nodeValue = 'Remove from compare';
                });
            }
        }
        // Activating the Bootstrap's Tooltip for showing some extra info when hovering over the main parts of the component
        jQuery('.CompareBtn [data-toggle="tooltip"]').tooltip();
        // Registering a click event handler for clearing the entire products comparison list and reseting some styles
        jQuery('.close', '.CompareBtn').on('click', function (evt) {
            // Clearing the cookies store
            createCookie('compare', '[]');
            // Clearing the cached comparison list array
            compareArray = [];
            // Hiding the component
            updateCompareProductsComponent(0, 'hide');
            // Reseting all of the elem references to the comparison list
            jQuery('.added-to-compare').removeClass('added-to-compare').find('.add-to-compare').each(function () {
                this.childNodes[0].nodeValue = 'Compare product ';
            });
        });
        // Registering a click event handler in all of the plus icons in the products' title in order to add to / remove from the 'compareArray'
        jQuery('.add-to-compare').click(function (evt) {
            evt.preventDefault();
            let badge = $('.btn.link-btn .badge').text();
            badge = parseInt(badge);
            let add = $(this).text();
            if (badge <= 4 || add == 'Remove from compare+') {
                // Caching the current product's ID
                var productId = jQuery(this).data('product');
                // Getting the latest value for the browser's cookie that is storing the list of products to compare
                compareCookie = getCookie('compare');
                // If cookie exists then update the array in 'compareArray' with cookie's properly parsed value
                if (compareCookie) {
                    compareArray = JSON.parse(compareCookie);
                    var isProductAlreadyInTheList = compareArray.indexOf(productId) !== -1;
                    // If product ID is already in the cookie's saved list then remove it from the list and update the cookie's value
                    if (isProductAlreadyInTheList) {
                        compareArray.splice(compareArray.indexOf(productId), 1);
                        // Otherwise include the new product ID into the cached array reference
                    } else {
                        compareArray.push(productId);
                    }
                    // And update the cookie's value with this new list
                    createCookie('compare', JSON.stringify(compareArray)); // If cookie doesn't exist then initiate its value with a single element array containing the current product's ID
                } else {
                    compareArray = [productId];
                    createCookie('compare', JSON.stringify([productId]));
                }
                // Highlight the targeted product if it is in the compare list and adjust copy text accordingly
                jQuery(this).parents('.product_container')[isProductAlreadyInTheList ? 'removeClass' : 'addClass']('added-to-compare').end().get(0).childNodes[0].nodeValue = isProductAlreadyInTheList ? 'Compare product ' : 'Remove from compare';
                // If comparison list has products in it then show the component and update its counter
                if (compareArray.length > 0) {
                    updateCompareProductsComponent(compareArray.length, 'show');
                    // Otherwise hide it for good
                } else {
                    updateCompareProductsComponent(0, 'hide');
                }
            } else {
                $(this).popover('enable');
                $(this).popover('show');
                setTimeout(() => {
                    $(this).popover('hide');
                    $(this).popover('disable');
                }, 2500);
                window.onscroll = function () {
                    $('.add-to-compare').popover('hide');
                    $('.add-to-compare').popover('disable');
                }
            }
        });

        // Compare Products page - Remove product from compare
        jQuery(".remove-to-compare").click(function (event) {
            var productId = jQuery(event.target).data("product");
            var compareCookie = getCookie("compare");
            if (!compareCookie) return;
            var compareArray = JSON.parse(compareCookie);
            if (!compareArray.includes(productId)) return;
            compareArray.splice(compareArray.indexOf(productId), 1);
            createCookie("compare", JSON.stringify(compareArray));
            jQuery('.compare-' + productId).remove();
            var tRows = jQuery('.ComparisonTable tr:not(.d-none)'),
                tCells = tRows.children('td');

            if (tRows.length * 2 === tCells.length) {
                tRows.append('<td></td>');
            }
            compareArray = JSON.parse(compareCookie);
            let lengthCompare = compareArray.length - 1;
            if (lengthCompare > 0) {
                updateCompareProductsComponent(lengthCompare, 'show');
                // Otherwise hide it for good
                if (lengthCompare <= 1) {
                    location.href = '/products';
                }
            } else {
                updateCompareProductsComponent(0, 'hide');
            }
        });

        // Create Cookie helper
        function createCookie(name, value, days) {
            var expires;

            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=".concat(date.toGMTString());
            } else {
                expires = "";
            }

            document.cookie = "".concat(name, "=").concat(value + expires, "; path=/");
        }

        // Get Cookie helper
        function getCookie(c_name) {
            if (document.cookie.length > 0) {
                var c_start = document.cookie.indexOf("".concat(c_name, "="));

                if (c_start != -1) {
                    c_start = c_start + c_name.length + 1;
                    var c_end = document.cookie.indexOf(";", c_start);

                    if (c_end == -1) {
                        c_end = document.cookie.length;
                    }

                    return unescape(document.cookie.substring(c_start, c_end));
                }
            }

            return undefined;
        }

        $('.btn.link-btn').on('click', function (evt) {
            evt.preventDefault();
            let badge = $(this).find('.badge').text();
            badge = parseInt(badge);
            if (badge >= 2) {
                location.href = $(this).attr('href');
            } else {

            }
        });
        tooltipCount(compareArray.length);
    });
}

ajaxCompare();

function ajaxPagination() {
    $('.products_listing_container .pagination a').on('click', function (evt) {
        evt.preventDefault();
        ajaxFilter($(this).attr('href'));
    });
}

function ajaxFilter(url) {
    $.ajax({
        url: url,
        method: 'GET',
        beforeSend: function beforeSend() {
            $('.products_listing_container').html($('.ajax-loading-gif'));
            $('.ajax-loading-gif').css('display', 'grid');
            $('html,body').animate({
                scrollTop: $('.product_category_title__container').offset().top
            }, 'slow');
        },
        success: function success(data, url) {
            var currCat = '',
                bgImg = '';
            currCat = $('.product-category-sidebar').find('a.active');
            console.log($(data).find('.product_category_listing .active'));
            bgImg = $(data).find('.product_category_title').css('background-image');
            // console.log(bgImg);
            $('.product_category_title').css('background-image', bgImg);
            //$('.product_category_title').replaceWith($(data).find('.product_category_title'));
            $('.product_category_title__container h1').replaceWith($(data).find('.product_category_title__container h1'));
            $('.products_listing_container').replaceWith($(data).find('.products_listing_container'));
            //$('.product_collection__container h2').replaceWith($(data).find('.product_collection__container h2'));
            document.title = $(data).filter('title').text();

            ajaxPagination();
            ajaxCompare();
            history.pushState({
                key: url
            }, '', this.url);
        },
        error: function error() {
            $('.products_listing_container').html('Network Error');
        }
    });
}


var elem_text = '';
var $h_v = '';

// SM-LLT 5-18-20 title switches from Products to All Products done on archive-product.php
//if ($('.turbo-air .product_category_title h1').text() == 'Products') {
//    $('.turbo-air .product_category_title h1').text('All Products');
//}
$(window).on('load', function () {
    if ($('.turbo-air .product_category_title h1').text() == 'All Products') {
        $h_v = $('.fix-wrapper-breadcrumbs a').eq(0).attr('href');
        $('.fix-wrapper-breadcrumbs').html('<a href="' + $h_v + '">Home</a> > <a href="' + $h_v + '/products">Products</a> > All Products');
    }
});

$(document).ready(function () {

    // SM-LLT 5-18-20 title switches from Products to All Products done on archive-product.php
    //if ($('.turbo-air .product_category_title h1').text() == 'Products') {
    //    $('.turbo-air .product_category_title h1').text('All Products');
    //}

    var grandParCat = $('.fix-wrapper-breadcrumbs a:contains("Product Category")');
    if ($('body.tax-product_cat').length && grandParCat.length && grandParCat.next('a').length) {
        var parCat = grandParCat.next().text();
        console.log(parCat);
        //$('.turbo-air .product_category_title h1').text(parCat);
        $('.product_collection h2').text(parCat);
    }


    $('.product_category_sidebar_nav a').on('click', function (evt) {
        evt.preventDefault();

        var $home_var = $('.fix-wrapper-breadcrumbs a').eq(0).attr('href');

        var curr_a = $(this);
        var add_text = '';
        if (curr_a.parent().parent().parent().prop("tagName") == 'DIV') {
            add_text = ' > ' + $(this).text();
        } else {
            var first = 0;
            while (curr_a.parent().parent().parent().prop("tagName") == 'LI') {
                if (first == 0) {
                    add_text = ' > ' + curr_a.text() + add_text;
                    first = 1;
                } else {
                    add_text = ' > ' + '<a href="' + curr_a.attr('href') + '">' + curr_a.text() + '</a>' + add_text;
                }
                curr_a = curr_a.parent().parent().parent().find('a').eq(0);
            }
            add_text = ' > ' + '<a href="' + curr_a.attr('href') + '">' + curr_a.text() + '</a>' + add_text;
        }

        var updatedCatName = curr_a.text();
        $('.turbo-air .product_collection h2').text(updatedCatName);
        //$('.turbo-air .product_category_title__container h1').text(updatedCatName);

        $('.fix-wrapper-breadcrumbs').html('<a href="' + $home_var + '">Home</a> > <a href="' + $home_var + '/products">Products</a> > <a href="'
            + $home_var + '/product-category/product-category">' + $(this).closest('.navigation').parent().find('div').eq(($(this).closest('.navigation').index() - 1) / 2).text() + '</a>' + add_text);
        var seriesCat = $('.fix-wrapper-breadcrumbs a:contains("Product by Series")');
        if (seriesCat) {
            var seriesCatHref = seriesCat.attr("href");
            seriesCat.attr('href', seriesCatHref + '/product-by-series');
        }
        ajaxFilter($(this).attr('href'));
    });

    $(document).on('click', '.woocommerce .products-per-page-pagination a', function (evt) {
        evt.preventDefault();
        ajaxFilter($(this).attr('href'));
    });
    $(document).on('change', '.woocommerce .sort-by select', function (evt) {
        evt.preventDefault();
        ajaxFilter($(this).val());
    });

});


$(document).on('click', '.product-category-sidebar a', function (evt) {
    //parent cat name
    var catTitle = $(this).parents('ul.navigation').prev('.product_category_sidebar_nav__title').text();

    if (catTitle.length && catTitle === 'Product by Series') {
        localStorage.setItem('productBySeries', true);
    } else {
        localStorage.setItem('productBySeries', false);
    }
});

$(document).on('click', '.recently-viewed-carousel a', function (e) {
    if (localStorage.getItem('productBySeries')) {
        console.log('here');
        localStorage.removeItem('productBySeries');
    }
});

$(document).on('click', '#searchform button', function (e) {
    if (localStorage.getItem('productBySeries')) {
        localStorage.removeItem('productBySeries');
    }
});

$(document).on('click', '#searchform button', function (e) {
    if (localStorage.getItem('productBySeries')) {
        localStorage.removeItem('productBySeries');
    }
});

//change single product breadcrumbs depending on localStorage value
function productBySeriesCrumbs() {
    var productBySeries = localStorage.getItem('productBySeries');
    if (productBySeries && productBySeries === 'true' && $('.single-product').length) {
        $('.product_listing_breadcrumb.default').hide();
        $('.product_listing_breadcrumb.by-series').show();
    }
}

$(document).ready(function () {

    productBySeriesCrumbs();
    ajaxPagination();
    // if ($('.thumbnails-wrapper .js-slide-item').length) {
    //     $image_src = $('.thumbnails-wrapper .js-slide-item').find('img').attr(src);
    // }

    if ( window.location.hash != '' )
    {
        $("html, body").animate({scrollTop: $(window.location.hash).offset().top - 200}, 500);
    }

    // Select all links with hashes
    $('#filter-block a[href*="#"], .turbo-air__footer a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            // On-page links

            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                var this_hash = $(this).prop("hash");

                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();


                    $('html, body').animate({
                        scrollTop: $('#offset_top_js').offset().top - 200
                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!

                        var $select_element = $('a[href="' + this_hash + '"]');

                        if ($select_element.length) {

                            $select_element.trigger('click');
                        }

                        var $target = $(target);
                        $target.focus();

                        if ($target.is(":focus")) { // Checking if the target was focused

                            return false;
                        } else {

                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }

                    });

                }
            }

        });


});

$(window).on('load', function () {

    var locationHash = document.location.hash;

    custom_js_theme.sliderProduct();

    if (locationHash && $('.sales_nav[href="' + locationHash + '"]')) {
        jQuery('.sales_nav a[href="' + locationHash + '"]').tab('show');
    }

    if (locationHash && $('#warranty-tabs-bar li a[href="' + locationHash + '"]')) {
        jQuery('#warranty-tabs-bar li a[href="' + locationHash + '"]').tab('show');
    }

    if (locationHash && $('.parts_dist_nav li a[href="' + locationHash + '"]')) {
        jQuery('.parts_dist_nav li a[href="' + locationHash + '"]').tab('show');
    }

});
